import { render } from "./Mo_modal_alert.vue?vue&type=template&id=0b05952f&scoped=true&ts=true"
import script from "./Mo_modal_alert.vue?vue&type=script&lang=ts"
export * from "./Mo_modal_alert.vue?vue&type=script&lang=ts"

import "./Mo_modal_alert.vue?vue&type=style&index=0&id=0b05952f&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1530414395/src/mediadept-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b05952f"]])

export default __exports__